import { mutateRoutingBoms } from "@/api/routingBoms/useRoutingBomsQuery";
import { useModal } from "@/features/modal/ModalStackManager";
import { FormButtonBox } from "@/features/standard/Form/FormButtonBox";
import { FormMain } from "@/features/standard/Form/FormMain";
import customAlert from "@/features/ui/alert/alert";
import { ItemAutoComplete } from "@/features/ui/autoComplete/item/item-autoComplete";
import { Box, Button, Group, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { DefaultApiRoutingBomsRoutingBomIdPutRequest, ItemsGet200ResponseRowsInnerItemTypeEnum, ItemsGet200ResponseRowsInnerRoutingsInnerRoutingBomsInner, RoutingBomsGetRequest } from "@sizlcorp/sizl-api-document/dist/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

const BomByOperationUpdateWrap = Object.assign(FormMain, {
    Button: Button,
    Input: TextInput,
    ButtonBox: FormButtonBox,
});

type BomByOperationUpdateFormProps = {
    data: ItemsGet200ResponseRowsInnerRoutingsInnerRoutingBomsInner
}

export const BomByOperationUpdateForm = ({ data }: BomByOperationUpdateFormProps) => {

    const queryClient = useQueryClient();
    const { closeModal } = useModal();

    const { mutate: updateMutate } = useMutation(
        (params: DefaultApiRoutingBomsRoutingBomIdPutRequest) =>
            mutateRoutingBoms.update(params).mutationFn(undefined),
        {
            onSuccess: () => {
                customAlert(
                    "Bom 수정에 성공하였습니다.",
                    "수정 성공",
                    "green"
                )
            },
            onError: (error: AxiosError<Error>) => {
                customAlert(
                    error.response?.data?.message ?? "Bom 수정에 실패하였습니다.",
                    "수정 실패",
                    "red"
                )
            }
        }
    );

    const form = useForm<RoutingBomsGetRequest>({
        initialValues: {
            itemCode: data.itemCode as string,
            seq: data.seq,
            quantity: data.quantity,
            routingCode: data.routingCode as string
        },
        validate: {
            itemCode: (value) => {
                if (!value) {
                    return "아이템 코드를 입력해주세요";
                }
            },
            seq: (value) => {
                if (!value) {
                    return "시퀀스를 입력해주세요";
                }
            },
            quantity: (value) => {
                if (!value) {
                    return "수량을 입력해주세요";
                }
            },
        }
    });

    const onSubmit = (values: RoutingBomsGetRequest) => {
        updateMutate({
            routingBomId: data.id as number,
            routingBomsGetRequest: values
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(['items']);
                closeModal({});
            },
        })
    }

    return (
        <Box>
            <form
                style={{
                    width: "100%",
                    display: "flex",
                    gap: "15px",
                    flexDirection: "column",
                }}
                onSubmit={form.onSubmit((values) => onSubmit(values))}
            >
                <BomByOperationUpdateWrap.Input
                    label="시퀀스"
                    {...form.getInputProps("seq")}
                />
                <ItemAutoComplete
                    getItemType={[
                        ItemsGet200ResponseRowsInnerItemTypeEnum.MATERIAL,
                        ItemsGet200ResponseRowsInnerItemTypeEnum.SEMI_PRODUCT,
                        ItemsGet200ResponseRowsInnerItemTypeEnum.SUBSIDIARY
                    ]}
                    label="아이템 이름"
                    {...form.getInputProps("itemCode")}

                />
                <BomByOperationUpdateWrap.Input
                    label="수량"
                    {...form.getInputProps("quantity")}
                />
                <Group position="right" mt="md">
                    <BomByOperationUpdateWrap.Button
                        type="submit"
                        color="yellow">
                        {"수정"}
                    </BomByOperationUpdateWrap.Button>
                </Group>
            </form>
        </Box>
    );
};

